"use client"

import { t } from "@/languages/i18n"
import { Form, FormInstance, Input, Radio, Select } from "antd"
import dynamic from "next/dynamic"
import React from "react"
const CKEditorComponent = dynamic(() => import("@/lib/config/lib/Ckeditor"), { ssr: false })

const { TextArea } = Input

interface Props {
  form: FormInstance
  domainOptions?: { label: string; value: string }[]
  onFormChange: () => void
}

const ContactFormUpsertForm: React.FC<Props> = ({ form, domainOptions, onFormChange }) => {
  return (
    <Form form={form} layout="vertical" onValuesChange={onFormChange} initialValues={{ resolved: false }}>
      <div className="grid grid-cols-2 gap-4">
        <Form.Item
          name="name"
          label={<span className="text-base font-medium">{t("Name")}</span>}
          rules={[{ required: true, message: t("Please enter name") }]}
        >
          <Input placeholder={t("Enter name")} />
        </Form.Item>
        <Form.Item
          name="email"
          label={<span className="text-base font-medium">{t("Email")}</span>}
          rules={[{ type: "email", required: true, message: t("Please enter valid email") }]}
        >
          <Input placeholder={t("Enter email")} />
        </Form.Item>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <Form.Item
          name="phone"
          label={<span className="text-base font-medium">{t("Phone")}</span>}
          rules={[
            { required: true, message: t("Vui lòng nhập số điện thoại") },
            { 
              pattern: /^[+0-9\s]+$/,
              message: t("Số điện thoại chỉ được chứa các chữ số từ 0-9") 
            }
          ]}
        >
          <Input placeholder={t("Enter phone")} />
        </Form.Item>
        <Form.Item name="company" label={<span className="text-base font-medium">{t("Company")}</span>}>
          <Input placeholder={t("Enter company")} />
        </Form.Item>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <Form.Item
          name="domain"
          label={<span className="text-base font-medium">{t("Domain")}</span>}
          rules={[{ required: true, message: t("Please select domain") }]}
        >
          <Select placeholder={t("Select domain")} options={domainOptions} showSearch allowClear />
        </Form.Item>
        <Form.Item name="resolved" label={<span className="text-base font-medium">{t("Resolved")}</span>}>
          <Radio.Group buttonStyle="solid">
            <Radio.Button value={false}>{t("False")}</Radio.Button>
            <Radio.Button value={true}>{t("True")}</Radio.Button>
          </Radio.Group>
        </Form.Item>
      </div>

      <Form.Item name="message" label={<span className="text-base font-medium">{t("Message")}</span>} className="mt-4">
        <CKEditorComponent
          value={form.getFieldValue("message")}
          onChange={data => {
            form.setFieldValue("message", data)
            onFormChange() // Đảm bảo gọi trigger thay đổi để component cha nhận biết
          }}
        />
      </Form.Item>
    </Form>
  )
}

export default ContactFormUpsertForm
